import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'

const NavigationMenu = loadable(() => import('@albatross/common-components/dist/components/UnicornNavigationMenu'))

const NavigationMenuContainer = (props) => {
  const {
    globalContent: { menuItems, dropdownMenu },
    venture, categories
  } = props

  const newMenuItems = categories?.length ? categories : menuItems

  return (
    <NavigationMenu
      venture={venture}
      categories={newMenuItems}
      dropdownsList={dropdownMenu}
    />
  )
}

NavigationMenuContainer.propTypes = {
  globalContent: PropTypes.object,
  venture: PropTypes.string,
  categories: PropTypes.array

}

export default NavigationMenuContainer
